module.exports = __webpack_public_path__ + "img/制御工学3_10_2.f70588b0.png";